/**
 * Normalises the shapes an async-thunk rejection can arrive in.
 *
 * `rejectWithValue(x)` puts x on `action.payload`; an uncaught throw leaves
 * payload undefined and fills `action.error` instead. Reading `payload.<field>`
 * without a guard throws inside the reducer, which aborts the whole dispatch.
 */
export const readThunkError = (action) => {
  const payload = action && action.payload;
  const error = action && action.error;

  if (payload) {
    if (typeof payload === "string") return payload;
    return payload.message || payload.error || payload;
  }

  return (error && error.message) || null;
};

export default readThunkError;
